var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var g = "@layer";
var k = Math.abs;
var $ = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
  return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
  return e.trim();
}
function j(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
  return e.replace(r, a);
}
function C(e, r, a) {
  return e.indexOf(r, a);
}
function O(e, r) {
  return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
  return e.slice(r, a);
}
function M(e) {
  return e.length;
}
function S(e) {
  return e.length;
}
function q(e, r) {
  return r.push(e), e;
}
function B(e, r) {
  return e.map(r).join("");
}
function D(e, r) {
  return e.filter(function (e) {
    return !j(e, r);
  });
}
var E = 1;
var F = 1;
var G = 0;
var H = 0;
var I = 0;
var J = "";
function K(e, r, a, n, c, s, t, u) {
  return {
    value: e,
    root: r,
    parent: a,
    type: n,
    props: c,
    children: s,
    line: E,
    column: F,
    length: t,
    return: "",
    siblings: u
  };
}
function L(e, r) {
  return m(K("", null, null, "", null, null, 0, e.siblings), e, {
    length: -e.length
  }, r);
}
function N(e) {
  while (e.root) e = L(e.root, {
    children: [e]
  });
  q(e, e.siblings);
}
function P() {
  return I;
}
function Q() {
  I = H > 0 ? O(J, --H) : 0;
  if (F--, I === 10) F = 1, E--;
  return I;
}
function R() {
  I = H < G ? O(J, H++) : 0;
  if (F++, I === 10) F = 1, E++;
  return I;
}
function T() {
  return O(J, H);
}
function U() {
  return H;
}
function V(e, r) {
  return A(J, e, r);
}
function W(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function X(e) {
  return E = F = 1, G = M(J = e), H = 0, [];
}
function Y(e) {
  return J = "", e;
}
function Z(e) {
  return y(V(H - 1, ne(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function _(e) {
  return Y(re(X(e)));
}
function ee(e) {
  while (I = T()) if (I < 33) R();else break;
  return W(e) > 2 || W(I) > 3 ? "" : " ";
}
function re(e) {
  while (R()) switch (W(I)) {
    case 0:
      q(se(H - 1), e);
      break;
    case 2:
      q(Z(I), e);
      break;
    default:
      q($(I), e);
  }
  return e;
}
function ae(e, r) {
  while (--r && R()) if (I < 48 || I > 102 || I > 57 && I < 65 || I > 70 && I < 97) break;
  return V(e, U() + (r < 6 && T() == 32 && R() == 32));
}
function ne(e) {
  while (R()) switch (I) {
    case e:
      return H;
    case 34:
    case 39:
      if (e !== 34 && e !== 39) ne(I);
      break;
    case 40:
      if (e === 41) ne(e);
      break;
    case 92:
      R();
      break;
  }
  return H;
}
function ce(e, r) {
  while (R()) if (e + I === 47 + 10) break;else if (e + I === 42 + 42 && T() === 47) break;
  return "/*" + V(r, H - 1) + "*" + $(e === 47 ? e : R());
}
function se(e) {
  while (!W(T())) R();
  return V(e, H);
}
function te(e) {
  return Y(ue("", null, null, null, [""], e = X(e), 0, [0], e));
}
function ue(e, r, a, n, c, s, t, u, i) {
  var f = 0;
  var o = 0;
  var l = t;
  var v = 0;
  var p = 0;
  var h = 0;
  var b = 1;
  var w = 1;
  var d = 1;
  var g = 0;
  var m = "";
  var x = c;
  var y = s;
  var j = n;
  var A = m;
  while (w) switch (h = g, g = R()) {
    case 40:
      if (h != 108 && O(A, l - 1) == 58) {
        if (C(A += z(Z(g), "&", "&\f"), "&\f", k(f ? u[f - 1] : 0)) != -1) d = -1;
        break;
      }
    case 34:
    case 39:
    case 91:
      A += Z(g);
      break;
    case 9:
    case 10:
    case 13:
    case 32:
      A += ee(h);
      break;
    case 92:
      A += ae(U() - 1, 7);
      continue;
    case 47:
      switch (T()) {
        case 42:
        case 47:
          q(fe(ce(R(), U()), r, a, i), i);
          break;
        default:
          A += "/";
      }
      break;
    case 123 * b:
      u[f++] = M(A) * d;
    case 125 * b:
    case 59:
    case 0:
      switch (g) {
        case 0:
        case 125:
          w = 0;
        case 59 + o:
          if (d == -1) A = z(A, /\f/g, "");
          if (p > 0 && M(A) - l) q(p > 32 ? oe(A + ";", n, a, l - 1, i) : oe(z(A, " ", "") + ";", n, a, l - 2, i), i);
          break;
        case 59:
          A += ";";
        default:
          q(j = ie(A, r, a, f, o, c, u, m, x = [], y = [], l, s), s);
          if (g === 123) if (o === 0) ue(A, r, j, j, x, s, l, u, y);else switch (v === 99 && O(A, 3) === 110 ? 100 : v) {
            case 100:
            case 108:
            case 109:
            case 115:
              ue(e, j, j, n && q(ie(e, j, j, 0, 0, c, u, m, c, x = [], l, y), y), c, y, l, u, n ? x : y);
              break;
            default:
              ue(A, j, j, j, [""], y, 0, u, y);
          }
      }
      f = o = p = 0, b = d = 1, m = A = "", l = t;
      break;
    case 58:
      l = 1 + M(A), p = h;
    default:
      if (b < 1) if (g == 123) --b;else if (g == 125 && b++ == 0 && Q() == 125) continue;
      switch (A += $(g), g * b) {
        case 38:
          d = o > 0 ? 1 : (A += "\f", -1);
          break;
        case 44:
          u[f++] = (M(A) - 1) * d, d = 1;
          break;
        case 64:
          if (T() === 45) A += Z(R());
          v = T(), o = l = M(m = A += se(U())), g++;
          break;
        case 45:
          if (h === 45 && M(A) == 2) b = 0;
      }
  }
  return s;
}
function ie(e, r, a, n, s, t, u, i, f, o, l, v) {
  var p = s - 1;
  var h = s === 0 ? t : [""];
  var b = S(h);
  for (var w = 0, d = 0, g = 0; w < n; ++w) for (var $ = 0, m = A(e, p + 1, p = k(d = u[w])), x = e; $ < b; ++$) if (x = y(d > 0 ? h[$] + " " + m : z(m, /&\f/g, h[$]))) f[g++] = x;
  return K(e, r, a, s === 0 ? c : i, f, o, l, v);
}
function fe(e, r, a, c) {
  return K(e, r, a, n, $(P()), A(e, 2, -2), 0, c);
}
function oe(e, r, a, n, c) {
  return K(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n, c);
}
function le(n, c, s) {
  switch (x(n, c)) {
    case 5103:
      return a + "print-" + n + n;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return a + n + n;
    case 4789:
      return r + n + n;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return a + n + r + n + e + n + n;
    case 5936:
      switch (O(n, c + 11)) {
        case 114:
          return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
        case 108:
          return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
        case 45:
          return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
      }
    case 6828:
    case 4268:
    case 2903:
      return a + n + e + n + n;
    case 6165:
      return a + n + e + "flex-" + n + n;
    case 5187:
      return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
    case 5443:
      return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
    case 4675:
      return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
    case 5548:
      return a + n + e + z(n, "shrink", "negative") + n;
    case 5292:
      return a + n + e + z(n, "basis", "preferred-size") + n;
    case 6060:
      return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
    case 4554:
      return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
    case 6187:
      return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
    case 5495:
    case 3959:
      return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
    case 4968:
      return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
    case 4200:
      if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
      break;
    case 2592:
    case 3360:
      return e + z(n, "template-", "") + n;
    case 4384:
    case 3616:
      if (s && s.some(function (e, r) {
        return c = r, j(e.props, /grid-\w+-end/);
      })) {
        return ~C(n + (s = s[c].value), "span", 0) ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span", 0) ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
      }
      return e + z(n, "-start", "") + n;
    case 4896:
    case 4128:
      return s && s.some(function (e) {
        return j(e.props, /grid-\w+-start/);
      }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (M(n) - 1 - c > 6) switch (O(n, c + 1)) {
        case 109:
          if (O(n, c + 4) !== 45) break;
        case 102:
          return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
        case 115:
          return ~C(n, "stretch", 0) ? le(z(n, "stretch", "fill-available"), c, s) + n : n;
      }
      break;
    case 5152:
    case 5920:
      return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function (r, a, c, s, t, u, i) {
        return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
      });
    case 4949:
      if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
      break;
    case 6444:
      switch (O(n, O(n, 14) === 45 ? 18 : 11)) {
        case 120:
          return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
        case 100:
          return z(n, ":", ":" + e) + n;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return z(n, "scroll-", "scroll-snap-") + n;
  }
  return n;
}
function ve(e, r) {
  var a = "";
  for (var n = 0; n < e.length; n++) a += r(e[n], n, e, r) || "";
  return a;
}
function pe(e, r, a, t) {
  switch (e.type) {
    case g:
      if (e.children.length) break;
    case i:
    case s:
      return e.return = e.return || e.value;
    case n:
      return "";
    case h:
      return e.return = e.value + "{" + ve(e.children, t) + "}";
    case c:
      if (!M(e.value = e.props.join(","))) return "";
  }
  return M(a = ve(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function he(e) {
  var r = S(e);
  return function (a, n, c, s) {
    var t = "";
    for (var u = 0; u < r; u++) t += e[u](a, n, c, s) || "";
    return t;
  };
}
function be(e) {
  return function (r) {
    if (!r.root) if (r = r.return) e(r);
  };
}
function we(n, t, u, i) {
  if (n.length > -1) if (!n.return) switch (n.type) {
    case s:
      n.return = le(n.value, n.length, u);
      return;
    case h:
      return ve([L(n, {
        value: z(n.value, "@", "@" + a)
      })], i);
    case c:
      if (n.length) return B(u = n.props, function (c) {
        switch (j(c, i = /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            N(L(n, {
              props: [z(c, /:(read-\w+)/, ":" + r + "$1")]
            }));
            N(L(n, {
              props: [c]
            }));
            m(n, {
              props: D(u, i)
            });
            break;
          case "::placeholder":
            N(L(n, {
              props: [z(c, /:(plac\w+)/, ":" + a + "input-$1")]
            }));
            N(L(n, {
              props: [z(c, /:(plac\w+)/, ":" + r + "$1")]
            }));
            N(L(n, {
              props: [z(c, /:(plac\w+)/, e + "input-$1")]
            }));
            N(L(n, {
              props: [c]
            }));
            m(n, {
              props: D(u, i)
            });
            break;
        }
        return "";
      });
  }
}
function de(e) {
  switch (e.type) {
    case c:
      e.props = e.props.map(function (r) {
        return B(_(r), function (r, a, n) {
          switch (O(r, 0)) {
            case 12:
              return A(r, 1, M(r));
            case 0:
            case 40:
            case 43:
            case 62:
            case 126:
              return r;
            case 58:
              if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
            case 32:
              return a === 1 ? "" : r;
            default:
              switch (a) {
                case 0:
                  e = r;
                  return S(n) > 1 ? "" : r;
                case a = S(n) - 1:
                case 2:
                  return a === 2 ? r + e + e : r + e;
                default:
                  return r;
              }
          }
        });
      });
  }
}
export { f as CHARSET, n as COMMENT, w as COUNTER_STYLE, s as DECLARATION, v as DOCUMENT, b as FONT_FACE, d as FONT_FEATURE_VALUES, i as IMPORT, h as KEYFRAMES, g as LAYER, u as MEDIA, r as MOZ, e as MS, p as NAMESPACE, t as PAGE, c as RULESET, l as SUPPORTS, o as VIEWPORT, a as WEBKIT, k as abs, X as alloc, q as append, m as assign, U as caret, P as char, I as character, J as characters, O as charat, F as column, B as combine, fe as comment, ce as commenter, te as compile, L as copy, Y as dealloc, oe as declaration, Z as delimit, ne as delimiter, ae as escaping, D as filter, $ as from, x as hash, se as identifier, C as indexof, G as length, N as lift, E as line, j as match, he as middleware, de as namespace, R as next, K as node, ue as parse, T as peek, H as position, le as prefix, we as prefixer, Q as prev, z as replace, ie as ruleset, be as rulesheet, ve as serialize, S as sizeof, V as slice, pe as stringify, M as strlen, A as substr, W as token, _ as tokenize, re as tokenizer, y as trim, ee as whitespace };